import React, { Fragment } from 'react'
import { Button, CardBody, Col, Container, Input, Row, Label, Table, Badge, FormGroup, ListGroup, ListGroupItem, CardHeader, ButtonGroup } from 'reactstrap'
import { useMicSampling } from '../../../hooks/micro/useMicSampling'
import { ModalRecollected } from '../micSampling/ModalRecollected'
import { ModalPreviewSamplings } from '../micSampling/ModalPreviewSamplings'
import { CanvasComponent } from '../../../components/canvas/CanvasComponent';
import './styleMic.css';
import Select from 'react-select';
import { ToolTips } from '../../../components/tooltips/ToolTips';
import { ConfigServer } from '../../../data/config';
import { policyFood, policyWater, PolicyContainer } from '../../../constant/microsanitaria'
import FormatNumbers from '../../../utils/formatNumbers';
import { ModalValidSamplings } from './ModalValidSamplings'
import { ModalCreateSample } from './ModalCreateSample'
import { cedimi, almas, pyrsa } from '../../../constant/globalConstantsTypeClients'
import { ListOptionsPaymentBy, OptionPaymentByCompany, OptionPaymentByPatient } from '../../../constant/workOrder';
import { ModalCreateSite } from './ModalCreateSite'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Card } from 'primereact/card';
import { Tag } from 'primereact/tag';
import '../../sanitary/styleQuoterMic/styleviewQuoter.css'
import DateRangePicker from 'react-bootstrap-daterangepicker'
import { CustomAlertDialogGlobal } from '../../alertDialog/CustomAlertDialogGlobal'



export const IndexMicSampling = () => {

    const {

        // * FORM SAMPLE
        loadingQuoter, formMicSampling, handleView,

        // * INPUTS
        handleNotCollected, handleToggleCollected, modalCollected, dataCollected,

        // * SAVE SAMPLINGS
        saveDetailSamplingsNotCollected, handleSearchSampling, handleResetSamplings, cancell_Samplings,

        // * SAMPLE FORM
        handleChangeSites, handleChangeArea, handleChangeSample, handleChangeQuantity, handleChangeObservations,
        handleRequiredTemperature, handleChangeThermometers, handleChangeTemperature, handleChangeSubject,

        // * LIST SAMPLES
        listSite, listArea, listSample, listThermometer,

        // * SAVE SAMPLINGS
        handleToggleSamplings, modalSamplings, handlePreviewSamplings, saveSamplings, loadingSamplings,

        // * VIEWS
        handleViewSamplings, handleDetermination, listNot,

        // * SAMPLING PLAN
        handleChangeFirm, repeatFirm, canvasRef1, canvasRef2,
        handleChangeObservationsPlan, handleChangeNumPlan, saveSamplingPlan,

        // * CALCULATE PRICES
        optionsTotal, total_tax,

        // * SAVE SAMPLINGS
        listPay, optionsPayment, handleAddPayMethod,
        handleDeletePayMethod, handleGiveChange, handleGiveMethod, saveMicroWorkorder, loadingMic, handleToggleValid, modalValid,
        handleChangePayMethod,

        // * INVOICES
        handleRequiredInvoice,

        // * QUATATION MIC
        handleNavigateSampling,

        // ? GLOBAL
        url_helen, nameBranch,

        // * MESSAGE SAMPLE
        handleNewSample, modalSample, toggleSample, handleText, saveCreateSample,

        // ! CONFIGURATION CEDIMI SAVE MICRO WORK ORDER
        saveSample, loadingCedimi, handleGoBack, customStyles,

        // * MODAL CREATE SITE
        handleNewSite, modalSite, toggleSite, handleTextSite, saveCreateSite,

        // * EDIT SAMPLINGS
        editSearchSampling, saveEditSamplings,

        //* delivery date
        minDate,
        handleApply,
        handleAutoSave,
        study_delivery,

        //* CUSTOM ALERT
        customAlert,

        users,
        loadingUsers,
        mSelectUser,
        handleSelectValues


    } = useMicSampling();


    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "12px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "12px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    console.log("paciente: ", formMicSampling.payment_company);
    console.log("SI MANDE MI CAMBIO")
    console.log("SI MANDE MI CAMBIO")



    return (
        <Fragment>
            <div className='container-global-zoom'>
                {loadingQuoter && <Row className='mt-2'>
                    <Col sm="12" md="12" lg="12" className='text-center'>
                        <img alt="flask" className='animate__animated animate__pulse animate__infinite' src={require("../../../assets/images/loginHelenLabs/HelenLabs.png")} style={{ width: "100px", height: "100px" }} />
                        <br />
                        <label className='txt-secondary f-w-600 f-18'  >Cargando</label>
                    </Col>
                </Row>}
                {
                    // ? LIST SAMPLINGS
                }
                <div className={!formMicSampling?.is_form ? "" : "d-none"}>
                    {
                        !loadingQuoter && <Row className='pt-0' >

                            <Col sm="12" md="12" lg="12" xl={formMicSampling?.is_detail ? "8" : "8"} className="p-r-0 p-t-0">
                                <Card className="sampling-card p-0">

                                    <div
                                        className={`sampling-card-header ${formMicSampling?.is_view === 3 || formMicSampling?.is_view === 2 ? "d-none" : ""
                                            }`}
                                    >
                                        <div className="sampling-card-title">
                                            <i className="fa fa-flask"></i>
                                            Recolección de Muestra
                                        </div>

                                        <Button
                                            onClick={handleGoBack}
                                            className="sampling-back-btn"
                                        >
                                            <i className="fa fa-arrow-left"></i>
                                            Regresar
                                        </Button>
                                    </div>


                                    {
                                        // * MENU
                                    }
                                    <br />
                                    <Row className={formMicSampling?.is_view === 3 ? "d-none" : ""} >
                                        <Col sm="12" md="12" lg="4">
                                            <Button type="button" color='light' onClick={() => handleView(1)} outline={formMicSampling?.is_view === 1 ? false : true} className='btn-block round btn-air-secondary text-center'  >
                                                <div className='w-100'>
                                                    <Col sm="12" style={{ textAlign: "center" }}>
                                                        <img alt="flask" src={require("../../../assets/images/price/tab1.svg")} style={{ height: "34px" }} />
                                                    </Col>
                                                </div>
                                                <span className='f-w-600 txt-secondary'>Recopilación de muestras</span>
                                            </Button>
                                        </Col>
                                        { // ! CONFIGURATION CEDIMI
                                            (url_helen === cedimi && listNot.length === 0) && <Col sm="12" md="12" lg="4" className='pt-3' style={{ textAlign: "center" }} >
                                                <h6 className='txt-secondary' >Número de seguimiento:</h6>
                                                <input disabled={formMicSampling?.firm_sampler_png !== null ? true : false} name="sampling_plan" value={formMicSampling?.sampling_plan} onChange={handleChangeNumPlan} className='input-borde-bajo' type="text" />
                                            </Col>
                                        }
                                        { // ! CONFIGURATION CEDIMI
                                            (url_helen === cedimi && listNot.length === 0) && <Col className={loadingCedimi ? "d-none" : ""} sm="12" md="12" lg="4">
                                                <Button type="button" color='info' outline onClick={() => saveSample()} className='btn-block round btn-air-success text-center'  >
                                                    <div className='w-100'>
                                                        <Col sm="12" style={{ textAlign: "center" }}>
                                                            <img alt="flask" src={require("../../../assets/images/price/tab5.svg")} style={{ height: "34px" }} />
                                                        </Col>
                                                    </div>
                                                    <span className='f-w-600 '>Generar Orden</span>
                                                </Button>
                                            </Col>
                                        }
                                        <Col sm="12" md="12" lg="4" className={url_helen === cedimi ? "d-none" : ""}>
                                            <Button onClick={() => handleView(2)} outline={formMicSampling?.is_view === 2 ? false : true} color="info" type="button" className='btn-block round btn-air-secondary text-center'   >
                                                <Col className={url_helen === cedimi ? "d-none" : ""} sm="12" style={{ textAlign: "center" }}>
                                                    <img alt="flask" src={require("../../../assets/images/price/tab4.svg")} style={{ height: "34px" }} />
                                                </Col>
                                                <span className={url_helen === cedimi ? "d-none f-w-600" : "f-w-600"} >Plan de muestreo</span>
                                            </Button>
                                        </Col>
                                        <Col sm="12" md="12" lg="4" className={(formMicSampling?.firm_client_png === null || formMicSampling?.firm_sampler_png === null) ? "d-none" : ""} >
                                            <Button onClick={() => handleView(3)} outline={formMicSampling?.is_view === 3 ? false : true} color="primary" type="button" disabled={listNot.length > 0 ? true : false} className='btn-block text-center' >
                                                <Col sm="12" style={{ textAlign: "center" }}>
                                                    <img alt="flask" src={require("../../../assets/images/price/tab5.svg")} style={{ height: "34px" }} />
                                                </Col>
                                                <span className='f-w-600'>Información de pago</span>
                                            </Button>
                                        </Col>

                                    </Row>
                                    {
                                        // ? VIEW 3
                                    }
                                    <Row className={formMicSampling?.is_view === 3 ? "" : "d-none"}>
                                        <Col sm="3" >
                                            <div className="media profile-media" >
                                                <img className="b-r-10 " src={ConfigServer.serverUrl + "/api/Configuration/Logo"} style={{ width: "80%" }} alt="Logo" />
                                            </div>
                                        </Col>
                                        <Col className='pt-3' sm="6" style={{ textAlign: "center" }}>
                                            <h6>REGISTRO DE TOMA Y CUSTODIA</h6>
                                        </Col>
                                        <Col sm="3" className='p-r-0 pt-3' style={{ textAlign: "right" }}>
                                            <label style={{ fontSize: "14px", color: "#6c757dc9" }} className='f-w-600 '>{nameBranch}</label>
                                        </Col>
                                    </Row>
                                    { // ? VIEW 1
                                        formMicSampling?.is_view === 1 &&
                                        <CardBody className='pl-2 pr-2' style={{ paddingTop: "20x", paddingLeft: "5px", paddingRight: "5px" }}>
                                            <div >
                                                { // ! CONFIGURATION CEDIMI -----save loading
                                                    (loadingCedimi && url_helen === cedimi)
                                                        ?
                                                        <>
                                                            <Row>
                                                                <Col sm="12" md="12" lg="12" className='text-center pt-5'>
                                                                    <img alt='modal-preview' src={require("../../../assets/images/loginHelenLabs/HelenLabs.png")} className='fa-spin' style={{ width: "10%" }} />
                                                                </Col>
                                                                <Col sm="12" md="12" lg="12" className='text-center mt-1'>
                                                                    <p className='txt-secondary'>Generando Admisión ...</p>
                                                                </Col>
                                                            </Row>
                                                        </>
                                                        :
                                                        <div className="table-responsive">
                                                            <DataTable
                                                                value={formMicSampling?.samples}
                                                                paginator
                                                                rows={10}
                                                                className="data-table p-datatable-striped p-datatable-sm"
                                                                emptyMessage={
                                                                    <div className="text-center">
                                                                        <img
                                                                            src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                                            style={{ width: "40%" }}
                                                                            alt="Sin Muestras"
                                                                        />
                                                                        <br />
                                                                        <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                                                            No hay muestras disponibles.
                                                                        </p>
                                                                    </div>
                                                                }
                                                                rowsPerPageOptions={[10, 50, 100]}
                                                                stripedRows
                                                                responsiveLayout="scroll"
                                                            >
                                                                <Column
                                                                    body={(rowData, { rowIndex }) => rowIndex + 1}
                                                                    header="#"
                                                                    headerStyle={{ ...headerStyle, textAlign: "center" }}
                                                                    style={{ ...cellStyle, textAlign: "center" }}
                                                                />
                                                                <Column
                                                                    body={(rowData) => (
                                                                        <div
                                                                            style={{
                                                                                backgroundColor: "#f97316",
                                                                                width: "120px",
                                                                                height: "25px",
                                                                                borderRadius: "8px",
                                                                                color: "#fff",
                                                                                fontSize: "10px",
                                                                                justifyContent: "center",
                                                                                alignItems: "center",
                                                                                textAlign: "center",
                                                                                margin: "0 auto",
                                                                                paddingTop: "2px",
                                                                            }}
                                                                        >
                                                                            <i className="fa fa-angle-right f-12" style={{ fontSize: "14px" }}></i>&nbsp;
                                                                            <label className="f-w-600" style={{ fontSize: "12px" }}>
                                                                                {rowData?.folio ?? "------"}
                                                                            </label>
                                                                        </div>
                                                                    )}
                                                                    header="Muestra"
                                                                    headerStyle={{ ...headerStyle, textAlign: "center" }}
                                                                    style={{ ...cellStyle, textAlign: "center" }}
                                                                />
                                                                <Column
                                                                    body={(rowData) => (
                                                                        <label className={`sampling-label ${rowData?.not_collected ? "not-collected" : ""}`}>
                                                                            {rowData?.name_Sampling?.name ?? "-----"}
                                                                        </label>
                                                                    )}
                                                                    header="Tipo de muestra"
                                                                    headerStyle={{ ...headerStyle, textAlign: "center" }}
                                                                    style={{ ...cellStyle, textAlign: "center" }}
                                                                />
                                                                <Column
                                                                    body={(rowData) => (
                                                                        <div
                                                                            style={{
                                                                                backgroundColor: rowData?.not_collected
                                                                                    ? "#f17985"
                                                                                    : rowData?.id_mic_detail_sample === null
                                                                                        ? "#6c757dc4"
                                                                                        : "#51bb25",
                                                                                width: "110px",
                                                                                height: "20px",
                                                                                borderRadius: "8px",
                                                                                color: "#fff",
                                                                                fontSize: "10px",
                                                                                justifyContent: "center",
                                                                                alignItems: "center",
                                                                                textAlign: "center",
                                                                                paddingTop: "2px",
                                                                                margin: "0 auto",
                                                                            }}
                                                                        >
                                                                            <i className="fa fa-circle-o f-12"></i>&nbsp;
                                                                            <label className="f-w-600" style={{ fontSize: "11px" }}>
                                                                                {rowData?.not_collected
                                                                                    ? "Cancelado"
                                                                                    : rowData?.id_mic_detail_sample === null
                                                                                        ? "Pendiente"
                                                                                        : "Completo"}
                                                                            </label>
                                                                        </div>
                                                                    )}
                                                                    header="Estado"
                                                                    headerStyle={{ ...headerStyle, textAlign: "center" }}
                                                                    style={{ ...cellStyle, textAlign: "center" }}
                                                                />


                                                                <Column
                                                                    header="Acciones"
                                                                    headerStyle={headerStyle}
                                                                    style={{ ...cellStyle, textAlign: "center" }}
                                                                    body={(rowData) => (
                                                                        <div className="d-flex justify-content-center gap-2">
                                                                            {/* <button
                                            onClick={() =>
                                                rowData?.id_mic_detail_sample === null
                                                ? handleSearchSampling(rowData?.id_quoter_type_sample)
                                                : handleViewSamplings(rowData?.id_quoter_type_sample)
                                            }
                                            title={rowData?.id_mic_detail_sample === null ? "Capturar" : "Visualizar"}
                                            style={{
                                                width: "30px",
                                                height: "30px",
                                                fontSize: "0.65rem",
                                                borderRadius: "8px",
                                                padding: "0",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }}
                                            className={rowData?.id_mic_detail_sample === null ? "btn btn-primary mr-1" : "btn btn-secondary mr-1"} 
                                        >
                                        <i className={rowData?.id_mic_detail_sample === null ? "pi pi-file-edit" : "pi pi-eye"} ></i>                         
                                        </button> */}

                                                                            <div className="d-flex justify-content-center gap-2">

                                                                                {/* Capturar */}
                                                                                {rowData?.id_mic_detail_sample === null && (
                                                                                    <button
                                                                                        onClick={() => handleSearchSampling(rowData?.id_quoter_type_sample)}
                                                                                        title="Capturar"
                                                                                        className="btnTableAction mr-1"
                                                                                        style={{
                                                                                            backgroundColor: "#0d69bf"
                                                                                        }}
                                                                                    >
                                                                                        <i className="pi pi-file-edit"></i>
                                                                                    </button>

                                                                                )}

                                                                                {/* Visualizar */}
                                                                                <button
                                                                                    onClick={() => handleViewSamplings(rowData?.id_quoter_type_sample)}
                                                                                    title="Visualizar información de la muestra"
                                                                                    className="btnTableAction mr-1"
                                                                                    style={{
                                                                                        backgroundColor: "#f77926"
                                                                                    }}
                                                                                >
                                                                                    <i className="pi pi-eye"></i>
                                                                                </button>

                                                                                {/* CANCELL SAMPLE */}
                                                                                {
                                                                                    !rowData?.not_collected &&
                                                                                    rowData?.id_mic_detail_sample === null && (
                                                                                        <button
                                                                                            onClick={() => handleNotCollected(rowData?.id_quoter_type_sample)}
                                                                                            title="Cancelar muestra"
                                                                                            className="btnTableAction mr-1"
                                                                                            style={{
                                                                                                backgroundColor: "#cf1515"
                                                                                            }}
                                                                                        >
                                                                                            <i className="fa fa-times"></i>
                                                                                        </button>
                                                                                    )
                                                                                }

                                                                            </div>



                                                                            {rowData?.not_collected
                                                                                ? ""
                                                                                : rowData?.id_mic_detail_sample === null
                                                                                    ? ""
                                                                                    : <button
                                                                                        onClick={() => editSearchSampling(rowData?.id_quoter_type_sample)}
                                                                                        title="Editar muestreo"
                                                                                        className={`btnTableAction ${url_helen === cedimi || formMicSampling?.firm_client_png !== null
                                                                                            ? "d-none"
                                                                                            : ""
                                                                                            }`}

                                                                                        style={{
                                                                                            backgroundColor: "#0d69bf"
                                                                                        }}
                                                                                    >
                                                                                        <i className="pi pi-id-card"></i>
                                                                                    </button>}
                                                                        </div>
                                                                    )}


                                                                />
                                                            </DataTable>
                                                        </div>
                                                }
                                            </div>
                                        </CardBody>
                                    }
                                    { // ? VIEW 2   
                                        formMicSampling?.is_view === 2 &&
                                        <CardBody className='pricingtable' style={formMicSampling?.firm_sampler_png === null ? { paddingTop: "1px", paddingLeft: "15px", paddingRight: "15px" } : { paddingTop: "1px", paddingLeft: "15px", paddingRight: "15px", height: "430px" }}>
                                            <Col sm="12" className='pt-4'>

                                                <Row className='pt-3'>
                                                    <Col className='pt-3' sm="12" md="12" lg="4" style={{ textAlign: "justify" }}>
                                                        <h6>Número de Plan de Muestreo:</h6>
                                                        <input disabled={formMicSampling?.firm_sampler_png !== null ? true : false} name="sampling_plan" value={formMicSampling?.sampling_plan} onChange={handleChangeNumPlan} className='input-borde-bajo' type="text" />
                                                    </Col>
                                                    <Col className='pt-3' sm="12" md="12" lg="8" style={{ textAlign: "left" }}>
                                                        <h6>Observaciones Generales:</h6>
                                                        <textarea
                                                            name="observations"
                                                            className="form-control input-air-primary form-control-sm "
                                                            value={formMicSampling?.observations}
                                                            onChange={handleChangeObservationsPlan}
                                                            style={{ fontSize: "11px" }}
                                                            disabled={formMicSampling?.firm_sampler_png !== null ? true : false}
                                                        />

                                                    </Col>
                                                </Row>

                                                <Col sm="12" className='pt-4 p-l-0' style={{ textAlign: "left" }}>
                                                    <h6>Muestras tomadas</h6>
                                                </Col>
                                                <div className='pt-1 mb-4' >
                                                    <Table className='b-r-5 table table-xs ' >
                                                        <thead className='b-r-5' style={{ textAlign: "center" }}>
                                                            <tr className='canvas-color' style={{ backgroundColor: "#f3f3f3", borderBottom: "#e3ebf3", borderTop: "#e3ebf3" }}>
                                                                <th >N°</th>
                                                                <th >Tipo de Muestra</th>
                                                                <th >Descripción de la muestra</th>
                                                                <th >Lugar de toma</th>
                                                                {/* <th >Hora</th> */}
                                                                <th >Temperatura</th>
                                                                <th >Cantidad</th>
                                                                <th >Observaciones</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                formMicSampling?.samples.length > 0 && (
                                                                    (() => {
                                                                        let localCounter = 0;
                                                                        return formMicSampling.samples.map((_item, _key) => {
                                                                            if (!_item?.not_collected && _item?.id_mic_sampling !== null) {
                                                                                localCounter++;
                                                                                return (
                                                                                    <tr key={_key}>
                                                                                        <td>{localCounter}</td>
                                                                                        <td>{_item?.name_Sampling?.name ?? "------"}</td>
                                                                                        <td>{_item?.name_mic_sample ?? "------"}</td>
                                                                                        <td>{_item?.name_mic_site ?? "------"}</td>
                                                                                        {/* <td>{_item?.date_collected ?? "------"}</td> */}
                                                                                        <td>{_item?.temperature === "" ? "------" : _item?.temperature ?? "------"}</td>
                                                                                        <td>{_item?.quantity === "          " ? "------" : _item?.quantity ?? "------"}</td>
                                                                                        <td>{_item?.observations === "" ? "------" : _item?.observations ?? "------"}</td>
                                                                                    </tr>
                                                                                );
                                                                            }

                                                                        });
                                                                    })()
                                                                )
                                                            }
                                                        </tbody>
                                                    </Table>
                                                </div>
                                                <Row className='pt-4'>
                                                    <Col sm="12" md="12" lg="6" className={formMicSampling?.firm_sampler_png !== null ? "pt-4" : ""}>
                                                        <label className='f-w-600 txt-secondary' >Responsable del muestreo</label>&nbsp; <br />
                                                        {formMicSampling?.firm_sampler_png === null && <i onClick={() => repeatFirm(canvasRef1, "sampler")} id={`tooltip-responsable`} className="icofont icofont-fountain-pen txt-danger f-20">
                                                            <ToolTips
                                                                placement="top"
                                                                dataTarget={`tooltip-responsable`}
                                                                dataText={'Repetir firma del responsable del muestreo'}
                                                            />
                                                        </i>}
                                                        {formMicSampling?.firm_sampler_png !== null && <img alt="flask" src={ConfigServer.serverUrl + "/api/QuoterDeterminations/GetPictureFirm/" + formMicSampling?.firm_sampler_png} />}
                                                        {formMicSampling?.firm_sampler_png === null && <CanvasComponent
                                                            canvasRef={canvasRef1}
                                                            handleChange={(ref) => handleChangeFirm(ref, "responsable")}
                                                            width={'820'}
                                                            height={200}
                                                            brushColor={"#000"}
                                                            brushRadius={1}
                                                            lazyRadius={3}
                                                        />}
                                                    </Col>
                                                    <Col sm="12" md="12" lg="6" className={formMicSampling?.firm_client_png !== null ? "pt-4" : ""} >
                                                        <label className='f-w-600 txt-secondary'>Firma del contacto/cliente</label>&nbsp; <br />
                                                        {formMicSampling?.firm_client_png === null && <i onClick={() => repeatFirm(canvasRef2, "client")} id={`tooltip-contacto`} className="icofont icofont-fountain-pen txt-danger f-20">
                                                            <ToolTips
                                                                placement="top"
                                                                dataTarget={`tooltip-contacto`}
                                                                dataText={'Repetir firma del responsable del contacto/cliente'}
                                                            />
                                                        </i>}
                                                        {formMicSampling?.firm_client_png !== null && <img alt="flask" src={ConfigServer.serverUrl + "/api/QuoterDeterminations/GetPictureFirm/" + formMicSampling?.firm_client_png} />}

                                                        {formMicSampling?.firm_client_png === null && <CanvasComponent
                                                            canvasRef={canvasRef2}
                                                            handleChange={(ref) => handleChangeFirm(ref, "cliente")}
                                                            width={'820'}
                                                            height={200}
                                                            brushColor={"#000"}
                                                            brushRadius={1}
                                                            lazyRadius={3}
                                                        />}
                                                    </Col>
                                                    {/* <Col sm="4">
                                <label className=' f-w-600 txt-secondary'>Firma de quien supervisa</label>&nbsp;
                                {formMicSampling.firm_sampler_png === null &&<i onClick={() => repeatFirm(canvasRef3, "superv")} id={`tooltip-supervisa`} className="icofont icofont-fountain-pen txt-danger f-20">
                                    <ToolTips
                                        placement="top"
                                        dataTarget={`tooltip-supervisa`}
                                        dataText={'Repetir firma del supervisador'}
                                    />
                                </i>}
                                {formMicSampling.firm_client_png !== null  && <img alt="flask" src={ConfigServer.serverUrl + "/api/QuoterDeterminations/GetPictureFirm/" + formMicSampling.firm_client_png} />}
                                {formMicSampling.firm_client_png === null && <CanvasComponent
                                    canvasRef={canvasRef3}
                                    handleChange={(ref) => handleChangeFirm(ref, "supervisor")}
                                    width={'820'}
                                    height={200}
                                    brushColor={"#000"}
                                    brushRadius={1}
                                    lazyRadius={3}
                                />}
                                </Col>  */}
                                                </Row>
                                            </Col>
                                            <Col className={formMicSampling?.firm_sampler_png === null ? "" : "d-none"} sm="12" style={{ textAlign: "end" }}>
                                                <ButtonGroup className='pt-3'>
                                                    <Button
                                                        className=" btn-air-danger "
                                                        color="secondary"
                                                        size="sm"
                                                        onClick={() => saveSamplingPlan()}
                                                    ><i className="icofont icofont-diskette f-14"></i>&nbsp;Guardar
                                                    </Button>
                                                    <Button
                                                        className=" btn-air-danger "
                                                        color="danger"
                                                        size="sm"
                                                    ><i className="icofont icofont-ui-close f-14"></i>&nbsp;Cancelar
                                                    </Button>
                                                </ButtonGroup>
                                            </Col>
                                        </CardBody>
                                    }
                                    {
                                        formMicSampling?.is_view === 3 &&
                                        <>
                                            {
                                                !loadingMic &&
                                                <Col sm="12" md="12" lg="12" xl="12" style={{ textAlign: "left" }} className='pricingtable'>
                                                    <div className='f-w-600 line-mic' style={{ backgroundColor: "#6c757d1a", height: "20px", textAlign: "center" }}>1.0 Datos del control</div>
                                                    <Row>
                                                        <Col sm="6"> <br />
                                                            &nbsp;<label className='f-w-600' style={{ fontSize: "11px" }}><i className="fa fa-circle text-info"></i> {"Empresa/Cliente:"}</label> <b style={{ fontSize: "10px" }}>{formMicSampling.is_company != null ? formMicSampling.quoter.name_company : formMicSampling.quoter.name_client} </b>  <br />
                                                            &nbsp;<label className='f-w-600' style={{ fontSize: "11px" }}> {"Dirección:"}</label> <b style={{ fontSize: "10px", color: "#898989" }}>{formMicSampling.is_company != null ? (formMicSampling.quoter.label_address === "" && formMicSampling.quoter.label_bussiness === "") ? "Por definir" : formMicSampling.quoter.label_address === "" ? (formMicSampling.quoter.label_bussiness) : (formMicSampling.quoter.label_address) : formMicSampling.quoter.label_address ?? "N/A"} </b>  <br />
                                                            &nbsp;<label className='f-w-600' style={{ fontSize: "11px" }}>{"Email:"}</label> <b style={{ fontSize: "10px", color: "#898989" }}>{formMicSampling.is_company != null ? formMicSampling.quoter.email : formMicSampling.quoter.email_client} </b>  <br />
                                                            &nbsp;<label className='f-w-600' style={{ fontSize: "11px" }}>{"Telefóno:"}</label> <b style={{ fontSize: "10px", color: "#898989" }}>{formMicSampling.is_company != null ? formMicSampling.quoter.phone : formMicSampling.quoter.phone_client} </b>  <br />
                                                        </Col>
                                                        <Col sm="6"> <br />
                                                            &nbsp;<label className='f-w-600' style={{ fontSize: "11px" }}> {"Cotización asociada:"}</label> <b style={{ fontSize: "10px", color: "#898989" }}>{formMicSampling.quoter.code} </b>  <br />.
                                                            <label className='f-w-600' style={{ fontSize: "11px" }}> {"N° Plan de Muestreo:"}</label> <b style={{ fontSize: "10px", color: "#898989" }}>{formMicSampling?.sampling_plan ?? "N/A"} </b>  <br />
                                                        </Col>
                                                    </Row>
                                                    <br />
                                                    <div className='f-w-600 line-mic' style={{ backgroundColor: "#6c757d1a", height: "20px", textAlign: "center" }}>2.0 Datos del muestreo</div>
                                                    <div className='pt-4'>
                                                        <Table className='b-r-5 table table-xs ' >
                                                            <thead className='b-r-5' style={{ textAlign: "center" }}>
                                                                <tr className='canvas-color' style={{ backgroundColor: "#f3f3f3", borderBottom: "#e3ebf3", borderTop: "#e3ebf3" }}>
                                                                    {/* <th >N°</th> */}
                                                                    <th >Tipo de Muestra</th>
                                                                    <th >Descripción de la muestra</th>
                                                                    <th >Lugar de toma</th>
                                                                    {/* <th >Hora</th> */}
                                                                    <th >Temperatura</th>
                                                                    <th >Cantidad</th>
                                                                    <th >Observaciones</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    formMicSampling?.samples.length > 0 && (
                                                                        (() => {
                                                                            let localCounter = 0;
                                                                            return formMicSampling?.samples.map((_item, _key) => {
                                                                                if (!_item?.not_collected && _item?.id_mic_sampling !== null) {
                                                                                    localCounter++;
                                                                                    return (
                                                                                        <tr key={_key}>
                                                                                            {/* <td>{localCounter}</td>  */}
                                                                                            <td>{_item?.name_Sampling?.name ?? "------"}</td>
                                                                                            <td>{_item?.name_mic_sample ?? "------"}</td>
                                                                                            <td>{_item?.name_mic_site ?? "------"}</td>
                                                                                            {/* <td>{_item?.date_collected ?? "------"}</td> */}
                                                                                            <td>{_item?.temperature === "" ? "------" : _item?.temperature ?? "------"}</td>
                                                                                            <td>{_item?.quantity === "          " ? "------" : _item?.quantity ?? "------"}</td>
                                                                                            <td>{_item?.observations === "" ? "------" : _item?.observations ?? "------"}</td>
                                                                                        </tr>
                                                                                    );
                                                                                }

                                                                            });
                                                                        })()
                                                                    )
                                                                }
                                                            </tbody>
                                                        </Table>

                                                    </div>
                                                    <br /> <br />
                                                    <label className='f-w-600'>Observaciones generales, cambios o desviaciones:</label>&nbsp;{formMicSampling?.observations}
                                                    <br /> <br /> <br />
                                                    <div className='f-w-600  line-mic' style={{ backgroundColor: "#6c757d1a", height: "20px", textAlign: "center" }}>3.0 Criterios de aceptación</div>
                                                    <label style={{ fontSize: "10px" }}>{policyFood}</label>
                                                    <label style={{ fontSize: "10px" }}>{policyWater}</label>
                                                    <label style={{ fontSize: "10px" }}>{PolicyContainer}</label>
                                                    <br /> <br />
                                                    <Row>
                                                        <Col sm="12" md="12" lg="6" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                                                            <div style={{ backgroundColor: "#6c757d1a", height: "25px", textAlign: "center", width: "100%" }}>Responsable del muestreo</div>
                                                            <br />
                                                            <div style={{ textAlign: "center", width: "400px", border: "1px solid #6c757d8f" }}>
                                                                {formMicSampling?.firm_sampler_png !== null &&
                                                                    <>
                                                                        <img
                                                                            width={"80%"}
                                                                            alt="flask"
                                                                            src={ConfigServer.serverUrl + "/api/QuoterDeterminations/GetPictureFirm/" + formMicSampling?.firm_sampler_png}
                                                                            onError={(e) => {
                                                                                e.target.style.display = 'none';
                                                                                document.getElementById('image-not-found').style.display = 'block';
                                                                            }}
                                                                        />
                                                                        <div className="search-not-found text-center">

                                                                        </div>


                                                                    </>
                                                                }
                                                            </div>
                                                        </Col>

                                                        <Col sm="12" md="12" lg="6" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                                                            <div style={{ backgroundColor: "#6c757d1a", height: "25px", textAlign: "center", width: "100%" }}>Firma del contacto/clienter</div>
                                                            <br />
                                                            <div style={{ textAlign: "center", width: "400px", border: "1px solid #6c757d8f" }}>
                                                                {
                                                                    formMicSampling.firm_client_png !== null &&
                                                                    <>
                                                                        <img
                                                                            width={"80%"}
                                                                            alt="flask"
                                                                            src={ConfigServer.serverUrl + "/api/QuoterDeterminations/GetPictureFirm/" + formMicSampling?.firm_client_png}
                                                                            onError={(e) => {
                                                                                e.target.style.display = 'none';
                                                                                document.getElementById('image-not-found').style.display = 'block';
                                                                            }}
                                                                        />
                                                                        <div className="search-not-found text-center">
                                                                            {/* <div>
                                        <img src={search} alt="" className="second-search" />
                                        <p className="mb-0">{"No se encontro la firma"}</p>
                                        </div> */}
                                                                        </div>

                                                                    </>
                                                                }

                                                            </div>
                                                        </Col>

                                                    </Row>
                                                    <br /> <br /> <br /> <br />
                                                    <br /> <br /> <br /> <br />
                                                </Col>
                                            }
                                            {
                                                loadingMic &&
                                                <>
                                                    <Row>
                                                        <Col sm="12" md="12" lg="12" className='text-center'>
                                                            <img alt='modal-preview' src={require("../../../assets/images/loginHelenLabs/HelenLabs.png")} className='fa-spin' style={{ width: "10%" }} />
                                                        </Col>
                                                        <Col sm="12" md="12" lg="12" className='text-center mt-1'>
                                                            <p>Generando admisión ...</p>
                                                        </Col>
                                                    </Row>
                                                </>
                                            }
                                        </>
                                    }
                                </Card>
                            </Col>
                            { // ? VIEW 1
                                formMicSampling?.is_view === 1 &&
                                <Col sm="12" md="12" lg="12" xl={formMicSampling?.is_detail ? "4" : "3"}  >
                                    <Card style={{ textAlign: "left" }} className=" pt-0 pb-0 pr-0 pl-0">
                                        <div className="contact-form">
                                            <div className="theme-form pl-0 pr-0 pt-0">

                                                {formMicSampling?.is_detail && <Col sm="12" className='p-0'>


                                                    <div className="sample-summary-card">

                                                        {formMicSampling?.sample_Detail?.date_sampling != null && (
                                                            <div className="sample-summary-row">
                                                                <div className="sample-summary-icon">
                                                                    <i className="fa fa-calendar"></i>
                                                                </div>

                                                                <div className="sample-summary-content">
                                                                    <span className="sample-summary-label">
                                                                        Fecha de muestreo
                                                                    </span>

                                                                    <span className="sample-summary-value">
                                                                        {formMicSampling.sample_Detail.date_sampling}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        )}

                                                        <div className="sample-summary-row">
                                                            <div className="sample-summary-icon">
                                                                <i className="fa fa-building"></i>
                                                            </div>

                                                            <div className="sample-summary-content">
                                                                <span className="sample-summary-label">
                                                                    Cliente
                                                                </span>

                                                                <span className="sample-summary-value">
                                                                    {formMicSampling?.sample_Detail?.name_company || "------"}
                                                                </span>
                                                            </div>
                                                        </div>

                                                    </div>










                                                    <div className="sample-detail-header">

                                                        <div className="sample-detail-title">
                                                            <i className="fa fa-flask"></i>
                                                            Información de la Muestra
                                                        </div>

                                                        <div className="sample-detail-folio">
                                                            <i className="fa fa-angle-right"></i>
                                                            {formMicSampling?.sample_Detail?.folio ?? "------"}
                                                        </div>

                                                    </div>



                                                    <Col sm="12" className="shadow-sm p-dialog-footer"
                                                        style={{
                                                            backgroundColor: 'white',
                                                            border: '1px solid #e0e0e0',
                                                            borderRadius: '10px',
                                                            padding: '12px',
                                                            fontSize: '12px'
                                                        }}>

                                                        {/* Título principal */}
                                                        <div style={{
                                                            fontWeight: 'bold',
                                                            background: '#0d3b59',
                                                            color: 'white',
                                                            padding: '6px',
                                                            borderRadius: '8px',
                                                            marginBottom: '10px',
                                                            textAlign: 'center',
                                                            fontSize: '14px'
                                                        }}>
                                                            Información de las Determinaciones
                                                        </div>


                                                        {/* Lista de determinaciones */}
                                                        <label style={{
                                                            fontWeight: "bold",
                                                            color: "#002940",
                                                            height: "25px",
                                                            padding: "3px",
                                                            display: "block",
                                                            marginTop: "25px",
                                                            marginBottom: "6px"
                                                        }} className='f-16 f-w-600 pl-2'>
                                                            {"Lista de determinaciones"}
                                                        </label>

                                                        {
                                                            formMicSampling?.sample_Detail?.list_Determinations.map((_obj, _key) => {
                                                                return (
                                                                    <ListGroup key={_key} style={{ marginBottom: "6px" }}>
                                                                        <ListGroupItem className="d-flex align-items-center list-group-item-action pt-1 pb-1 pr-0 pl-0">
                                                                            <img
                                                                                alt="flask"
                                                                                className="img-fluid text-info mr-2"
                                                                                src={require("../../../assets/images/typeService.svg")}
                                                                                style={{ height: "23px" }}
                                                                            />
                                                                            <label style={{ fontSize: "12px" }} className='f-w-600 label-dashboard'>
                                                                                <strong>{_obj?.name ?? "-----"}</strong>
                                                                            </label>
                                                                        </ListGroupItem>
                                                                    </ListGroup>
                                                                )
                                                            })
                                                        }

                                                        {/* Indicaciones de las determinaciones */}
                                                        <label style={{
                                                            fontWeight: "bold",
                                                            color: "#002940",
                                                            height: "25px",
                                                            padding: "3px",
                                                            display: "block",
                                                            marginTop: "25px",
                                                            marginBottom: "6px"
                                                        }} className='f-16 f-w-600 pl-2'>
                                                            {"Indicacion de las determinaciones"}
                                                        </label>

                                                        {
                                                            formMicSampling?.sample_Detail?.list_Determinations &&
                                                            formMicSampling.sample_Detail.list_Determinations.length > 0 &&
                                                            <ul style={{ paddingLeft: '1.5rem', marginTop: '0.5rem' }}>
                                                                {
                                                                    formMicSampling.sample_Detail.list_Determinations.flatMap((_obj, _key) =>
                                                                        _obj.listIndication?.map((_ind, _key2) => (
                                                                            <li key={`${_key}-${_key2}`} className='label-dashboard' style={{ color: "#495057", fontWeight: 600 }}>
                                                                                -{_ind.indication ?? "-------"}
                                                                            </li>
                                                                        )) || []
                                                                    )
                                                                }
                                                            </ul>
                                                        }

                                                        {/* Normas aplicadas */}
                                                        <label style={{
                                                            fontWeight: "bold",
                                                            color: "#002940",
                                                            height: "25px",
                                                            padding: "3px",
                                                            display: "block",
                                                            marginTop: "25px",
                                                            marginBottom: "6px"
                                                        }} className='f-16 f-w-600 pl-2'>
                                                            {"Normas aplicadas"}
                                                        </label>

                                                        {
                                                            formMicSampling?.sample_Detail?.list_Determinations &&
                                                            formMicSampling.sample_Detail.list_Determinations.length > 0 &&
                                                            <div className="activity-timeline">
                                                                {
                                                                    formMicSampling.sample_Detail.list_Determinations.flatMap((_obj, _key) =>
                                                                        _obj.list_nom?.map((_nom, _key2) => (
                                                                            <div className="media" style={{ marginTop: "2px" }} key={`${_key}-${_key2}`}>
                                                                                <div className=""></div>
                                                                                <div className="media-body label-dashboard " style={{ marginTop: "2px" }}>
                                                                                    <span style={{ color: "#495057" }} className='f-w-600 label-dashboard '>
                                                                                        {_nom.name ?? "-------"}
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        )) || []
                                                                    )
                                                                }
                                                            </div>
                                                        }


                                                    </Col>
                                                    <br />
                                                    {!formMicSampling?.is_determination && <Col sm="12" className={formMicSampling.sample_Detail.not_collected ? "d-none" : 'p-l-0 p-r-0 pt-2 shadow-sm p-dialog-footer'}
                                                        style={{
                                                            backgroundColor: 'white',
                                                            border: '1px solid #e0e0e0',
                                                            borderRadius: '10px',
                                                            padding: '12px',
                                                            fontSize: '12px'
                                                        }}>
                                                        <div style={{
                                                            fontWeight: 'bold',
                                                            background: formMicSampling?.sample_Detail.date_collected === null ? '#98a6ad' : '#51bb25',
                                                            color: 'white',
                                                            padding: '6px',
                                                            borderRadius: '8px',
                                                            marginBottom: '10px',
                                                            textAlign: 'center',
                                                            fontSize: '14px'
                                                        }}>
                                                            {formMicSampling?.sample_Detail.date_collected === null ? "Muestra no recolectada" : "Esta muestra fue recolectada"}

                                                        </div>
                                                        <Row>
                                                            <Col sm="7">
                                                                <div className="activity-timeline">
                                                                    <div className="media">
                                                                        <div className="-line"></div>
                                                                        <div className={formMicSampling?.sample_Detail.date_collected === null ? "activity-dot-dark" : "activity-dot-success"}></div>
                                                                        <div className="media-body"><span className='txt-secondary f-w-600'>{"Tipo de muestra"}</span>
                                                                            <p className="font-roboto">{formMicSampling?.sample_Detail?.name_Sampling.name ?? "---------"}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </Col>

                                                            <Col sm="5">
                                                                <div className="activity-timeline">
                                                                    <div className="media">
                                                                        <div className="-line"></div>
                                                                        <div className={formMicSampling?.sample_Detail.date_collected === null ? "activity-dot-dark" : "activity-dot-success"}></div>
                                                                        <div className="media-body"><span className='txt-secondary f-w-600'>{"Fecha de muestreo"}</span>
                                                                            <p className='f-w-600' style={{ color: "#6c757db8" }}>{formMicSampling?.sample_Detail.date_collected === null ? "No disponible" : formMicSampling?.sample_Detail.date_collected}</p>

                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </Col>

                                                            <Col sm="7">
                                                                <div className="activity-timeline">
                                                                    <div className="media">
                                                                        <div className="-line"></div>
                                                                        <div className={formMicSampling?.sample_Detail.date_collected === null ? "activity-dot-dark" : "activity-dot-success"}></div>
                                                                        <div className="media-body"><span className='txt-secondary f-w-600'>{"Sitio"}</span>
                                                                            <p className="font-roboto">{formMicSampling?.sample_Detail?.name_mic_site ?? "-------"}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Col>

                                                            <Col sm="5">
                                                                <div className="activity-timeline">
                                                                    <div className="media">
                                                                        <div className="-line"></div>
                                                                        <div className={formMicSampling?.sample_Detail.date_collected === null ? "activity-dot-dark" : "activity-dot-success"}></div>
                                                                        <div className="media-body"><span className='txt-secondary f-w-600'>{"Cantidad"}</span>
                                                                            <p className="font-roboto">{formMicSampling?.sample_Detail?.quantity === "          " ? "------" : formMicSampling?.sample_Detail?.quantity}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </Col>

                                                            {
                                                                formMicSampling?.sample_Detail?.id_mic_site === 12 && <Col sm="12">
                                                                    <div className="activity-success">
                                                                        <div className="media">
                                                                            <div className="-line"></div>
                                                                            <div className={formMicSampling?.sample_Detail.date_collected === null ? "activity-dot-dark" : "activity-dot-success"}></div>
                                                                            <div className="media-body"><span className='txt-secondary f-w-600'>{"Sujeto Muestreado"}</span>
                                                                                <p className="font-roboto">{formMicSampling?.sample_Detail?.subject ?? "-------"}</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </Col>
                                                            }

                                                            <Col sm="6">
                                                                <div className="activity-timeline">
                                                                    <div className="media">
                                                                        <div className="-line"></div>
                                                                        <div className={formMicSampling?.sample_Detail.date_collected === null ? "activity-dot-dark" : "activity-dot-success"}></div>
                                                                        <div className="media-body"><span className='txt-secondary f-w-600'>{"Descripción"}</span>
                                                                            <p className="font-roboto">{formMicSampling?.sample_Detail?.name_mic_sample ?? "-------"}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Col>

                                                            <Col sm="8">
                                                                <div className="activity-timeline">
                                                                    <div className="media">
                                                                        <div className="activity-"></div>
                                                                        <div className={formMicSampling?.sample_Detail.date_collected === null ? "activity-dot-dark" : "activity-dot-success"}></div>
                                                                        <div className="media-body"><span className='txt-secondary f-w-600'>{"Observaciones"}</span>
                                                                            <p className="font-roboto">{formMicSampling?.sample_Detail?.observations === "" ? "--------" : formMicSampling?.sample_Detail?.observations ?? "-------"}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Col>


                                                        </Row>
                                                        {formMicSampling?.sample_Detail?.required_temperature && <Row className='pt-3 pl-1'>
                                                            <Col sm="12" className='pl-4'>
                                                                <label style={{ color: "#000000b8" }} className='f-18 f-w-600 '>Temperatura</label> <br />
                                                                <Col sm="12">
                                                                    <div className="activity-timeline">
                                                                        <div className="media">
                                                                            <div className="-line"></div>
                                                                            <div className="activity-dot-primary"></div>
                                                                            <div className="media-body"><span className='txt-secondary f-w-600'>{"Termometro"}</span>
                                                                                <p className="font-roboto">{formMicSampling?.sample_Detail?.name_thermometer ?? "-------"}</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </Col>
                                                                <Col sm="12">
                                                                    <div className="activity-timeline">
                                                                        <div className="media">
                                                                            <div className="-line"></div>
                                                                            <div className="activity-dot-primary"></div>
                                                                            <div className="media-body"><span className='txt-secondary f-w-600'>{"Temperatura"}</span>
                                                                                <p className="font-roboto">{formMicSampling?.sample_Detail?.temperature ?? "--------"}°C</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </Col>
                                                                <br />

                                                            </Col>
                                                        </Row>}



                                                    </Col>}
                                                    {
                                                        formMicSampling.sample_Detail.not_collected &&
                                                        <Col sm="12" className="shadow-sm p-dialog-footer"
                                                            style={{
                                                                backgroundColor: 'white',
                                                                border: '1px solid #e0e0e0',
                                                                borderRadius: '10px',
                                                                padding: '12px',
                                                                fontSize: '12px'
                                                            }} >
                                                            <div style={{
                                                                fontWeight: 'bold',
                                                                background: '#c0130aff',
                                                                color: 'white',
                                                                padding: '6px',
                                                                borderRadius: '8px',
                                                                marginBottom: '10px',
                                                                textAlign: 'center',
                                                                fontSize: '14px'
                                                            }}>
                                                                Esta muestra no fue recolectada
                                                            </div>
                                                        </Col>
                                                    } <br />



                                                </Col>}
                                            </div>
                                        </div>
                                    </Card>
                                </Col>
                            }
                            {
                                // ? VIEW 2
                                formMicSampling?.is_view === 2 &&
                                <Col sm="12" md="12" lg="12" xl="4" className='p-r-0 shadow  ' >
                                    <Card>
                                        <Col style={{
                                            backgroundColor: 'white',
                                            border: '1px solid #e0e0e0',
                                            borderRadius: '10px',
                                            padding: '12px',
                                            fontSize: '12px'
                                        }} className='pricingtable' >
                                            <div style={{
                                                fontWeight: 'bold',
                                                background: '#0d3b59',
                                                color: 'white',
                                                padding: '6px',
                                                borderRadius: '8px',
                                                marginBottom: '10px',
                                                textAlign: 'center',
                                                fontSize: '14px'
                                            }}>
                                            </div>
                                            <ul className="pricing-content ">
                                                <li>{policyFood}</li>
                                                <li>{policyWater}</li>
                                                <li>{PolicyContainer}</li>
                                            </ul>
                                        </Col>
                                        {/* <div className="pricingtable pl-1 pt-1 pr-0 pb-0">
                                <div className="pricingtable-header">
                                <h6 className="title txt-secondary">{"Criterios de Aceptación"}</h6>
                                </div>
                                <ul className="pricing-content ">
                                    <li>{policyFood}</li>
                                    <li>{policyWater}</li>
                                    <li>{PolicyContainer}</li>
                                </ul>
                            </div> */}
                                    </Card>
                                </Col>
                            }
                            {   // ? VIEW 3 
                                formMicSampling?.is_view === 3 &&
                                <Col sm="12" md="12" lg="12" xl="4" className='p-r-0' >
                                    <Card style={loadingMic ? { filter: "opacity(0.5)" } : {}}   >
                                        <Col sm="12" md="12" lg="12" className='p-l-0 p-0'>
                                            <div className="movement-card-header">
                                                <div className="movement-card-title">
                                                    <i className="fa fa-file-text-o"></i>
                                                    <span>Detalles de Movimimientos</span>
                                                </div>

                                                <Button
                                                    color="light"
                                                    size="sm"
                                                    className="movement-back-btn"
                                                    onClick={() => handleNavigateSampling(formMicSampling?.code)}
                                                >
                                                    <i className="fa fa-arrow-left mr-1"></i>
                                                    Regresar
                                                </Button>
                                            </div>

                                            <div className='hr-detail-patient '></div>
                                            <br />
                                            {formMicSampling?.payment_by_company &&
                                                formMicSampling?.payment_by_patient &&
                                                formMicSampling?.payment_company === null && (
                                                    <div
                                                        style={{
                                                            background: "#fff8e1",
                                                            border: "1px solid #ffc107",
                                                            borderLeft: "5px solid #ff9800",
                                                            borderRadius: "10px",
                                                            padding: "12px",
                                                            marginTop: "15px",
                                                            marginBottom: "10px"
                                                        }}
                                                    >
                                                        <div className="d-flex align-items-center">
                                                            <i
                                                                className="fa fa-exclamation-circle"
                                                                style={{
                                                                    color: "#ff9800",
                                                                    fontSize: "22px",
                                                                    marginRight: "10px"
                                                                }}
                                                            ></i>

                                                            <div>
                                                                <div
                                                                    style={{
                                                                        fontWeight: "700",
                                                                        color: "#b26a00",
                                                                        fontSize: "14px"
                                                                    }}
                                                                >
                                                                    Acción requerida
                                                                </div>

                                                                <div
                                                                    style={{
                                                                        fontSize: "13px",
                                                                        color: "#6c757d"
                                                                    }}
                                                                >
                                                                    Selecciona a quién se le cargará el pago para continuar.
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            {

                                                (formMicSampling?.payment_by_company && formMicSampling?.payment_by_patient) &&
                                                <Select
                                                    isDisabled={loadingMic}
                                                    classNamePrefix='select'
                                                    name="payment_by"
                                                    options={ListOptionsPaymentBy}
                                                    value={
                                                        formMicSampling?.payment_company === null
                                                            ? null
                                                            : formMicSampling.payment_company
                                                                ? OptionPaymentByCompany
                                                                : OptionPaymentByPatient
                                                    }
                                                    onChange={(e) => handleChangePayMethod(e)}
                                                    placeholder={"Selecciona una opcion"}
                                                    valid
                                                    menuPortalTarget={document.body}
                                                    theme={
                                                        (theme) => ({
                                                            ...theme,
                                                            colors: {
                                                                ...theme.colors,
                                                                primary25: '#898989'
                                                            }
                                                        })
                                                    }
                                                />
                                            }
                                            <Col sm="12" className='p-l-0 p-r-0 pb-5' >
                                                <Row className={formMicSampling?.is_company !== null ? "d-none" : "mt-3"}>
                                                    <Col sm="12">
                                                        <div className="movement-section">
                                                            <div className="movement-box">

                                                                <label className="movement-box-title">
                                                                    Facturación
                                                                </label>

                                                                <div className="movement-switch-card">

                                                                    <div className="movement-switch-text">
                                                                        <i className="fa fa-file-text-o"></i>
                                                                        <span>Requiere factura</span>
                                                                    </div>

                                                                    <Label className="switch mb-0">
                                                                        <Input
                                                                            type="checkbox"
                                                                            name="require_invoice"
                                                                            disabled={loadingMic}
                                                                            checked={formMicSampling.require_invoice}
                                                                            onClick={handleRequiredInvoice}
                                                                        />
                                                                        <span className="slider round"></span>
                                                                    </Label>

                                                                </div>

                                                            </div>
                                                        </div>

                                                    </Col>
                                                </Row>

                                                <div
                                                    className={`movement-section ${formMicSampling?.is_company !== null ? "mt-3" : "d-none"
                                                        }`}
                                                >
                                                    <Row>

                                                        {/* GENERAR PAGO */}
                                                        <Col sm="6">
                                                            <div className="movement-box">

                                                                <label className="movement-box-title">
                                                                    Generar pago a
                                                                </label>

                                                                <div className="movement-box-content">

                                                                    <i className="fa fa-dot-circle-o"></i>

                                                                    <span>
                                                                        {
                                                                            formMicSampling?.payment_company
                                                                                ? "Empresa"
                                                                                : "Paciente"
                                                                        }
                                                                    </span>

                                                                </div>

                                                            </div>
                                                        </Col>

                                                        {/* FACTURA */}
                                                        <Col sm="6">

                                                            <div className="movement-box">

                                                                <label className="movement-box-title">
                                                                    Generar factura a
                                                                </label>

                                                                {
                                                                    formMicSampling?.available_invoice_patient
                                                                        ?

                                                                        <div className="movement-box-switch">

                                                                            <Label className="switch mb-0">
                                                                                <Input
                                                                                    type="checkbox"
                                                                                    disabled={loadingQuoter}
                                                                                    checked={formMicSampling.require_invoice}
                                                                                    onClick={handleRequiredInvoice}
                                                                                />
                                                                                <span className="slider round"></span>
                                                                            </Label>

                                                                        </div>

                                                                        :

                                                                        <div className="movement-box-content">

                                                                            <i className="fa fa-dot-circle-o"></i>

                                                                            <span>
                                                                                {
                                                                                    formMicSampling?.require_invoice
                                                                                        ? "Empresa"
                                                                                        : "Paciente"
                                                                                }
                                                                            </span>

                                                                        </div>

                                                                }

                                                            </div>

                                                        </Col>

                                                    </Row>
                                                </div>

                                                <div className="movement-section">

                                                    <div className="movement-section-header">
                                                        <span className="movement-section-title">
                                                            RESUMEN DE COSTOS
                                                        </span>
                                                    </div>

                                                    <div className="movement-total-card">
                                                        <div className="movement-row">
                                                            <span>Subtotal</span>
                                                            <strong>
                                                                $ {FormatNumbers(optionsTotal.subtotal, 2)}
                                                            </strong>
                                                        </div>
                                                        <div className="movement-row">
                                                            <span>
                                                                I.V.A
                                                                <span className="movement-tax">
                                                                    {total_tax}%
                                                                </span>
                                                            </span>

                                                            <strong>
                                                                $ {FormatNumbers(optionsTotal.tax, 2)}
                                                            </strong>
                                                        </div>

                                                        <div className="movement-total-box">
                                                            <span>Monto Total</span>
                                                            <h3>
                                                                $ {FormatNumbers(optionsTotal.total, 2)}
                                                            </h3>
                                                        </div>

                                                    </div>
                                                    <br />
                                                </div>

                                                <div
                                                    className={`movement-section ${formMicSampling.payment_company !== null ? "mb-3" : "d-none"
                                                        }`}
                                                >


                                                    <Row>

                                                        <Col sm="6">
                                                            <span className="movement-section-title">
                                                                MÉTODOS DE PAGO
                                                            </span>
                                                        </Col>

                                                        <Col sm="6" className="text-right">

                                                            <Button
                                                                color="primary"
                                                                className="movement-add-btn"
                                                                onClick={handleAddPayMethod}
                                                                disabled={loadingMic}
                                                            >
                                                                <i className="fa fa-plus mr-1"></i>
                                                                Agregar
                                                            </Button>

                                                        </Col>

                                                    </Row>

                                                    {
                                                        formMicSampling.payment_company !== null &&
                                                        optionsPayment?.listPayMethods.map((_payMethod, _key) => (

                                                            <div
                                                                key={`method-${_key}`}
                                                                className={_payMethod.deleted ? "d-none" : "payment-card"}
                                                            >

                                                                <Row>

                                                                    <Col md="6">

                                                                        <label>Método de pago</label>

                                                                        <Input
                                                                            disabled={(_payMethod.id_pay_method === 10 || loadingMic)}
                                                                            type="select"
                                                                            className="movement-input"
                                                                            name="id_pay_method"
                                                                            data-id={_key}
                                                                            value={_payMethod.id_pay_method}
                                                                            onChange={(e) =>
                                                                                handleGiveMethod(e, "id_pay_method", "listPayMethods")
                                                                            }
                                                                        >

                                                                            <option value={0}>
                                                                                Selecciona una opción
                                                                            </option>

                                                                            {
                                                                                listPay.map(_method => (

                                                                                    <option
                                                                                        key={_method.id_pay_method}
                                                                                        value={_method.id_pay_method}
                                                                                    >
                                                                                        {_method.name}
                                                                                    </option>

                                                                                ))
                                                                            }

                                                                        </Input>

                                                                    </Col>

                                                                    <Col md="5">

                                                                        <label>Monto</label>

                                                                        <Input
                                                                            disabled={loadingMic || _payMethod.id_pay_method === 10}
                                                                            className="movement-input"
                                                                            data-id={_key}
                                                                            name="amount"
                                                                            placeholder="$ 0.00"
                                                                            value={_payMethod.amount || ""}
                                                                            onChange={(e) =>
                                                                                handleGiveChange(e, "amount", "listPayMethods")
                                                                            }
                                                                        />

                                                                    </Col>

                                                                    <Col md="1" className="payment-delete mt-4">

                                                                        <i
                                                                            className="fa fa-trash"
                                                                            onClick={() => handleDeletePayMethod(_key)}
                                                                        ></i>

                                                                    </Col>

                                                                </Row>

                                                            </div>

                                                        ))
                                                    }
                                                </div>

                                                <div className="movement-section">

                                                    <div className="movement-section-header">
                                                        <span className="movement-section-title">
                                                            FECHA DE ENTREGA
                                                        </span>
                                                    </div>

                                                    <div className="movement-total-card">
                                                        <div className="date-input-wrapper">
                                                            <i className="pi pi-calendar"></i>
                                                            <DateRangePicker
                                                                initialSettings={{
                                                                    singleDatePicker: true,
                                                                    showDropdowns: true,
                                                                    minDate: minDate,
                                                                    timePicker: true,
                                                                    timePicker24Hour: true,
                                                                    drops: 'up',
                                                                    opens: 'right',
                                                                    locale: {
                                                                        format: 'YYYY-MM-DD HH:mm',
                                                                        applyLabel: 'Aceptar',
                                                                        cancelLabel: 'Cancelar',
                                                                        daysOfWeek: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
                                                                        monthNames: [
                                                                            'Enero',
                                                                            'Febrero',
                                                                            'Marzo',
                                                                            'Abril',
                                                                            'Mayo',
                                                                            'Junio',
                                                                            'Julio',
                                                                            'Agosto',
                                                                            'Septiembre',
                                                                            'Octubre',
                                                                            'Noviembre',
                                                                            'Diciembre'
                                                                        ],
                                                                    },
                                                                }}
                                                                onApply={handleApply}
                                                                onChange={handleAutoSave}
                                                                onHide={handleAutoSave}
                                                            >
                                                                <input
                                                                    type="text"
                                                                    readOnly
                                                                    className={`date-input ${study_delivery ? 'has-value' : ''}`}
                                                                    value={study_delivery}
                                                                    placeholder="Fecha de entrega"
                                                                />
                                                            </DateRangePicker>

                                                        </div>
                                                    </div>

                                                    <br />
                                                </div>

                                                <Col
                                                    sm="12"
                                                    className={formMicSampling.payment_company !== null ? "mt-4" : "d-none"}
                                                >

                                                    <Button
                                                        block
                                                        color="primary"
                                                        className="movement-generate-btn"
                                                        disabled={loadingMic}
                                                        onClick={() => saveMicroWorkorder(2)}
                                                    >
                                                        <i className="fa fa-check-circle mr-2"></i>
                                                        Generar Orden
                                                    </Button>

                                                </Col>

                                            </Col>

                                        </Col>

                                    </Card>


                                    {/* <Card>
                                <Col sm="12" md="12" lg="12" xl="12" style={{textAlign:"left"}} className='pl-4 pr-4 pt-4 p-b-0 pricingtable' >
                                
                                <Row className='pt-4' >
                                    <Col sm="12">
                                    <h6 className='txt-secondary pt-2'>Resúmen</h6>
								<div className='hr-detail-patient '></div>
                                <Row className="pb-4 pt-2">
                              
                                    <Col sm="12" md="12" lg="12" className='pt-1'>
                                    <label style={{fontSize:"12px"}} className='f-w-600 '><i className="fa fa-circle text-info"></i> Acciones</label> <br /> 
									{
								   <div className='pointer input-borde-bajo' 
                                   style={{backgroundColor :"#f8d62b", color:"#fff", paddingBottom:"5px", paddingTop:"1px", textAlign:"center"}} 
                                   onClick={() => handleNavigateSampling(formMicSampling?.code)} ><i className="fa fa-file-pdf-o"></i> Editar Muestreo</div>
									}
                                    </Col>
                                </Row>
								<Row className='pt-1'>
									<Col sm="12" md="12" lg="12">
									<label style={{fontSize:"12px"}} className='f-w-600 '><i className="fa fa-circle text-info"></i> Resúmen del pago</label> 
									</Col>
								</Row >
								<div  className="table-responsive pt-1">
									<Table style={{ fontSize: "11px" }}>
										<thead>
											<tr className='input-borde-bajo' style={{ backgroundColor: "#46AFE5" }}>
												<td colSpan={2} style={{ color: "#fff", textAlign: "center", padding: "5px" }}>
													Detalle de movimientos
												</td>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td style={{ padding: "5px" }}>
													<label className='f-12'>Subtotal</label>
												</td>
												<td className="text-center" style={{ padding: "5px" }}>
													<label>$ {FormatNumbers(optionsTotal.subtotal,2)}</label>
												</td>
											</tr>
											<tr>
												<td style={{ padding: "5px" }}>
                                                <label style={{fontSize:"13px"}} className={total_tax === 16 ? 'f-w-600 txt-primary' : 'f-w-600 txt-secondary' }  >I.V.A({total_tax}%)</label>
												</td>
												<td className="text-center" style={{ padding: "5px" }}>
													<label>$ {FormatNumbers(optionsTotal.tax,2)}</label>
												</td>
											</tr>
											<tr>
												<td style={{ padding: "5px" }}>
													<label style={{fontSize:"13px"}} className='f-w-600'>Total</label>
												</td>
												<td className="text-center f-w-600 bg-dark" style={{ padding: "5px" }}>
													<label style={{fontSize:"13px"}} className='f-w-600'>$ {FormatNumbers(optionsTotal.total,2)}</label>
												</td>
											</tr>
										</tbody>
									</Table>
								</div> <br />
                                    </Col>
                                   

                                    <br />
                                    <Col sm="12"  className='p-l-0 pt-4 pl-1 pr-1 pt-4' >
                                    <Row className={formMicSampling.payment_company !== null ? "" :"d-none"}>
                                        <Col sm="12" className='pb-4' style={{textAlign:"right"}} >
                                        <Button disabled={loadingMic ? true : false} type='button' className='btn-air-primary' outline color='primary' size='sm' onClick={handleAddPayMethod}>
                                            <i className='fa fa-plus'></i> Método de pago
                                        </Button>
                                        </Col>
                                    </Row>
                                    {
                                        formMicSampling.payment_company !== null &&
                                        <Table >
                                            <thead>
                                                <tr className='text-center border-bottom-info'>
                                                <th className='p-1 f-12'><label className='text-WorkOrder f-14'>Método de pago</label></th>
                                                <th className='p-1 f-12'><label className='text-WorkOrder f-14'>Monto</label></th>
                                                <th className='p-1 f-12'><label className='text-WorkOrder f-14'>Acciones</label></th>
                                                <th className='p-1'></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    optionsPayment?.listPayMethods.map((_payMethod,_key) => {
                                                    return(
                                                        <tr key={`method-${_key}`} className={_payMethod?.deleted ? 'd-none' : ''}>
                                                            <td>
                                                            <Input disabled={ (_payMethod.id_pay_method === 10 || loadingMic) ? true : false} type="select" required={true} className='form-control form-control-sm input-air-primary p-1' name='id_pay_method' data-id={_key}  onChange={(e) => handleGiveMethod(e, 'id_pay_method', 'listPayMethods')} value={_payMethod?.id_pay_method} >
                                                                <option value={0}>Selecciona una opción</option>
                                                                    {
                                                                    listPay.map(_method => {
                                                                        return (
                                                                        <option   value={_method?.id_pay_method} key={`method-${_method?.id_pay_method}`}>{_method?.name ?? "------"}</option>
                                                                        )  
                                                                    })
                                                                    }
                                                            </Input>
                                                            </td>
                                                            <td>
                                                            <Input
                                                                disabled={ (loadingMic || _payMethod.id_pay_method === 10) ? true : false}                                        
                                                                data-id={_key}
                                                                name="amount"
                                                                className='form-control input-air-primary form-control-sm'
                                                                placeholder='$ 0.0'
                                                                value={_payMethod.amount || ''}
                                                                onChange={(e) => handleGiveChange(e, 'amount', 'listPayMethods')}
                                                            />
                                                            </td>
                                                            <td style={{textAlign:"center"}}>
                                                                <i className='fa fa-trash-o txt-danger f-24 pointer' onClick={() => handleDeletePayMethod(_key)} ></i>
                                                            </td>
                                                            </tr>
                                                            )
                                                        })
                                                    }
                                            </tbody>                     
                                        </Table>
                                          }
                                        <Col sm="12" className={formMicSampling.payment_company !== null ? "pt-2 pb-4" :"d-none"}  style={{textAlign:"right"}} >
                                        <Button className={ loadingMic ?"progress-bar-animated progress-bar-striped" :""}  disabled={loadingMic ? true: false} outline color='primary' size='sm' onClick={() => saveMicroWorkorder(2) }>
                                            Generar Orden
                                        </Button>
                                        </Col>
                                    </Col>
                                </Row>
                                </Col> 
                            </Card> */}
                                </Col>
                            }
                        </Row>
                    }
                </div>
                {/* <br /> <br /> <br /> <br /> */}
                {
                    // ? SAMPLE FORM
                }
                {formMicSampling?.is_form && <Col sm="12" className=" p-l-1 p-r-1 pt-3">

                    {
                        // ? FORM SAMPLINGS SAVE
                    }
                    <Card className='shadow'>
                        <Col sm="12" style={{ paddingTop: "10px", paddingBottom: "10px" }}>
                            {
                                // ? SAMPLE DATA
                            }
                            <Row  >
                                <Col sm="12" md="12" lg="9" className='p-l-0 p-r-0' >


                                    <div style={{ padding: "20px" }} className="contact-form pt-0 ">
                                        <div className="theme-form pl-3 shadow-sm" style={{
                                            backgroundColor: 'white', border: '1px solid #e0e0e0',
                                            borderRadius: '10px', padding: '12px', fontSize: '12px'
                                        }}>
                                            <div className="form-icon"><img alt="flask" className=" text-info mr-2" src={require("../../../assets/images/price/microType.svg")} style={{ width: "65px", height: "605px" }} />
                                            </div>
                                            <FormGroup>
                                                <label className='f-16 f-w-600 pl-2'>
                                                    {"Datos de la muestra"}  <Tag severity="warning" className='f-14' style={{ boxShadow: "0 6px 12px rgba(0,0,0,0.25)" }} value={formMicSampling?.sample_Form?.folio}  ></Tag>
                                                </label>
                                            </FormGroup>
                                            <Col sm="12">
                                                <Row>
                                                    <Col sm="12" md="12" lg="12" xl="3" className='p-r-0'>
                                                        <FormGroup>
                                                            <label className='label-quoter-mic' style={{ color: "#565a5efc", fontWeight: "bold", fontSize: "15px" }} >{"Tipo de muestra"}</label>
                                                            <Input disabled={true} style={{ fontSize: "13px", backgroundColor: "#6c757d17", color: "#495057", fontWeight: "500", height: "40px" }} value={formMicSampling?.sample_Form?.name_Sampling.name} className="form-control" type="text" />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col sm="12" md="12" lg="12" xl="3">
                                                        <FormGroup>
                                                            <label className='label-quoter-mic' style={{ color: "#565a5efc", fontWeight: "bold", fontSize: "15px" }} >{"Sitio"} <span className='txt-info f-14 ' >*</span>  <i className="fa fa-edit f-18 pointer txt-secondary " onClick={handleNewSite}></i>  </label>
                                                            <Select
                                                                classNamePrefix="select"
                                                                name="id_mic_site"
                                                                value={formMicSampling?.is_edit_site
                                                                    ? { value: formMicSampling?.sample_Form?.id_mic_site, label: formMicSampling?.sample_Form?.name_mic_site }
                                                                    : formMicSampling?.sample_Form?.id_mic_site}
                                                                placeholder="Selecciona un sitio"
                                                                options={listSite}
                                                                onChange={(e) => handleChangeSites(e)}
                                                                styles={customStyles}
                                                                menuPortalTarget={document.body}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    {
                                                        formMicSampling?.sample_Form?.id_mic_site?.value === 12 && <Col>
                                                            <FormGroup>
                                                                <label className='label-quoter-mic' style={{ color: "#565a5efc", fontWeight: "bold", fontSize: "15px" }} >{"Sujeto Muestreado"}</label>
                                                                <Input value={formMicSampling?.sample_Form?.subject} onChange={handleChangeSubject} style={{ fontSize: "13px", height: "40px", color: "#495057" }} className="form-control" type="text" />
                                                            </FormGroup>
                                                        </Col>

                                                    }
                                                    {(url_helen !== almas && url_helen !== pyrsa) && <Col sm="12" md="12" lg="12" xl="3">
                                                        <FormGroup>
                                                            <label className='label-quoter-mic' style={{ color: "#565a5efc", fontWeight: "bold", fontSize: "15px" }} >{"Area"}</label>
                                                            <Select
                                                                classNamePrefix="select"
                                                                name="id_mic_site_areas"
                                                                value={formMicSampling?.is_edit
                                                                    ? { value: formMicSampling?.sample_Form?.id_mic_site_areas, label: formMicSampling?.sample_Form?.name_mic_site }
                                                                    : formMicSampling?.sample_Form?.id_mic_site_areas}
                                                                placeholder="Selecciona un sitio"
                                                                options={listArea}
                                                                onChange={(e) => handleChangeArea(e, formMicSampling?.is_edit)}
                                                                styles={customStyles}
                                                                menuPortalTarget={document.body}
                                                            />
                                                        </FormGroup>
                                                    </Col>}
                                                    <Col sm="12" md="12" lg="12" xl="3" className={(formMicSampling?.sample_Form?.id_mic_site?.value === 12 && url_helen === cedimi) ? "pt-3" : ""} >
                                                        <FormGroup>
                                                            <label className='label-quoter-mic' style={{ color: "#565a5efc", fontWeight: "bold", fontSize: "15px" }}  >{"Descripción de muestra"} <span className='txt-info f-14' >*</span>  <i className="fa fa-edit f-18 pointer txt-secondary " onClick={handleNewSample}></i>  </label>
                                                            <Select
                                                                classNamePrefix="select"
                                                                name="id_mic_sample"
                                                                value={formMicSampling?.is_edit_id_mic_sample
                                                                    ? { value: formMicSampling?.sample_Form?.id_mic_sample, label: formMicSampling?.sample_Form?.name_mic_sample }
                                                                    : formMicSampling?.sample_Form?.id_mic_sample}
                                                                placeholder="Selecciona un sitio"
                                                                options={listSample}
                                                                onChange={(e) => handleChangeSample(e)}
                                                                styles={customStyles}
                                                                menuPortalTarget={document.body}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col sm="12" md="12" lg="12" xl="3" className={formMicSampling?.sample_Form?.id_mic_site?.value === 12 ? "pt-3" : ""}>
                                                        <FormGroup>
                                                            <label className='label-quoter-mic' style={{ color: "#565a5efc", fontWeight: "bold", fontSize: "15px" }} >{"Cantidad"}</label>
                                                            <Input value={formMicSampling?.sample_Form?.quantity} onChange={handleChangeQuantity} style={{ fontSize: "13px", height: "40px", color: "#495057" }} className="form-control" type="text" />
                                                        </FormGroup>
                                                    </Col>

                                                    <Col sm="12" md="12" lg="12" xl="4" className={(formMicSampling?.sample_Form?.id_mic_site?.value === 12 && url_helen === cedimi) ? "pt-3" : ""} >
                                                        {url_helen === pyrsa && (

                                                            <FormGroup>
                                                                <label className='label-quoter-mic' style={{ color: "#565a5efc", fontWeight: "bold", fontSize: "15px" }}  >{"Responsable de muestreo"} <span className='txt-info f-14' >*</span></label>
                                                                <Select
                                                                    name="mSelectUser"
                                                                    isClearable
                                                                    placeholder="Selecciona un usuario"
                                                                    options={users}
                                                                    onChange={(e) => handleSelectValues(e, 'mSelectUser')}
                                                                    value={mSelectUser}
                                                                    className="select-branch"
                                                                    classNamePrefix="select"
                                                                    styles={{
                                                                        control: (base) => ({
                                                                            ...base,
                                                                            textAlign: "left",
                                                                        }),
                                                                        singleValue: (base) => ({
                                                                            ...base,
                                                                            textAlign: "left",
                                                                            width: "100%",
                                                                        }),
                                                                        option: (base) => ({
                                                                            ...base,
                                                                            textAlign: "left",
                                                                        }),
                                                                    }}
                                                                />
                                                            </FormGroup>
                                                        )}
                                                    </Col>
                                                    <Col className={formMicSampling?.sample_Form?.id_mic_site?.value === 12 ? "pt-3" : ""} sm="12" md="12" lg="12" xl={url_helen === almas ? "9" : (formMicSampling?.sample_Form?.id_mic_site?.value === 12) ? "6" : "8"} >
                                                        <FormGroup>
                                                            <label className='label-quoter-mic' style={{ color: "#565a5efc", fontWeight: "bold", fontSize: "15px" }} >{"Observaciones"}</label>
                                                            <Input value={formMicSampling?.sample_Form?.observations} onChange={handleChangeObservations} style={{ fontSize: "13px", height: "40px", color: "#495057" }} className="form-control" type="text" />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </Col>


                                        </div>
                                    </div> <br /><br />
                                    <div style={{ padding: "20px" }} className="contact-form pt-0">
                                        <div className="theme-form pl-3 shadow-sm" style={{
                                            backgroundColor: 'white', border: '1px solid #e0e0e0',
                                            borderRadius: '10px', padding: '12px', fontSize: '12px'
                                        }}>
                                            <div className="form-icon"><img alt="flask" className=" text-info mr-2" src={require("../../../assets/images/price/temperature_micro.svg")} style={{ width: "58px", height: "605px" }} />
                                            </div>
                                            <FormGroup>
                                                <label style={{
                                                    fontWeight: "bold",
                                                    color: "#002940",
                                                    height: "25px",
                                                    padding: "3px",
                                                    display: "block",
                                                    marginTop: "25px",
                                                    marginBottom: "6px"
                                                }} className='f-16 f-w-600 pl-2 label-quoter-mic'>
                                                    {"Temperatura de la muestra"}
                                                </label>

                                            </FormGroup>
                                            <Col sm="12">
                                                <Row>
                                                    <Col sm="1"> <br /><br />
                                                        <Label className="switch mb-0">
                                                            <Input
                                                                type="checkbox"
                                                                name="optionTermo"
                                                                onChange={handleRequiredTemperature}
                                                                checked={formMicSampling?.sample_Form?.required_temperature}
                                                            />
                                                            <span className="slider round"></span>
                                                        </Label>

                                                    </Col>
                                                    <Col sm="10">
                                                        {
                                                            formMicSampling?.sample_Form?.required_temperature && <Col sm="12" className='p-l-0 p-r-0'>
                                                                <Row>
                                                                    <Col sm="12" md="12" lg="12" xl="6" className='p-r-0'>
                                                                        <FormGroup>
                                                                            <label className='label-quoter-mic' style={{ color: "#565a5efc", fontWeight: "bold", fontSize: "15px" }} >{"Termometro"}</label>
                                                                            <Select
                                                                                classNamePrefix="select"
                                                                                name="id_thermometer"
                                                                                value={formMicSampling?.is_edit_thermometer
                                                                                    ? { value: formMicSampling?.sample_Form?.id_thermometer, label: formMicSampling?.sample_Form?.name_thermometer }
                                                                                    : formMicSampling?.sample_Form?.id_thermometer}
                                                                                placeholder="Selecciona un termometro"
                                                                                options={listThermometer}
                                                                                onChange={(e) => handleChangeThermometers(e)}
                                                                                styles={customStyles}
                                                                                menuPortalTarget={document.body}
                                                                            />
                                                                        </FormGroup>

                                                                    </Col>
                                                                    <Col sm="12" md="12" lg="12" xl="3" className='p-r-0'>
                                                                        <FormGroup>
                                                                            <label className='label-quoter-mic' style={{ color: "#565a5efc", fontWeight: "bold", fontSize: "15px" }} >{"Temperatura °C."}</label>
                                                                            <Input type="number"
                                                                                step="0.1" onChange={handleChangeTemperature} value={formMicSampling?.sample_Form?.temperature} disabled={formMicSampling?.sample_Form?.id_thermometer ? false : true} style={formMicSampling?.sample_Form?.id_thermometer ? { fontSize: "16px", color: "#495057", fontWeight: "500", height: "40px", textAlign: "center" } : { backgroundColor: "#6c757d17", height: "40px" }} className="form-control" />
                                                                        </FormGroup>

                                                                    </Col>
                                                                    <Col sm="12" md="12" lg="12" xl="3">

                                                                        <FormGroup>
                                                                            <label className='label-quoter-mic' style={{ color: "#565a5efc", fontWeight: "bold", fontSize: "15px" }} >{"Temperatura Corregida °C"}</label>
                                                                            <Input disabled={true} style={{ fontSize: "16px", backgroundColor: "#6c757d17", color: "#495057", fontWeight: "500", height: "40px", textAlign: "center" }} className="form-control" value={formMicSampling?.sample_Form?.temperature !== "" ? formMicSampling?.sample_Form?.factor_correction2 : formMicSampling?.sample_Form?.factor_correction} type="text" />
                                                                        </FormGroup>
                                                                    </Col>

                                                                </Row>
                                                            </Col>
                                                        }

                                                    </Col>
                                                </Row>

                                            </Col>


                                        </div>
                                    </div>


                                </Col>
                                <Col sm="12" md="12" lg="12" xl="3" className='p-r-0 pt-0 p-l-0'>
                                    <div style={{ padding: "20px" }} className="contact-form pt-0">
                                        <div className="theme-form pr-0 pl-2 shadow-sm" style={{
                                            backgroundColor: 'white', border: '1px solid #e0e0e0',
                                            borderRadius: '10px', padding: '12px', fontSize: '12px'
                                        }}>
                                            <div className="form-icon"><img alt="flask" className=" text-info mr-2" src={require("../../../assets/images/price/determinations_Micro.svg")} style={{ width: "58px", height: "605px" }} />
                                            </div>
                                            <FormGroup>
                                                <label style={{
                                                    fontWeight: "bold",
                                                    color: "#002940",
                                                    height: "25px",
                                                    padding: "3px",
                                                    display: "block",
                                                    marginTop: "25px",
                                                    marginBottom: "6px"
                                                }} className='f-16 f-w-600 pl-2 label-quoter-mic'>
                                                    {"Lista de determinaciones"}
                                                </label>
                                            </FormGroup>
                                            <Col sm="12">
                                                {
                                                    formMicSampling?.sample_Form?.list_Determinations.map((_obj, _key) => {
                                                        return (
                                                            <ListGroup>
                                                                <ListGroupItem className="d-flex align-items-center list-group-item-action pt-1 pb-1 pr-0 pl-0">
                                                                    <img alt="flask" className="img-fluid text-info mr-2" src={require("../../../assets/images/typeService.svg")} style={{ height: "23px" }} /> <label style={{ fontSize: "12px" }} className='f-w-500 label-dashboard'>{_obj?.name ?? "-----"}</label>
                                                                </ListGroupItem>
                                                            </ListGroup>
                                                        )
                                                    })
                                                }
                                            </Col>
                                        </div>
                                    </div> <br /><br />
                                    <div style={{ padding: "20px" }} className="contact-form pt-0">
                                        <div className="theme-form pr-0 pl-2 shadow-sm" style={{
                                            backgroundColor: 'white', border: '1px solid #e0e0e0',
                                            borderRadius: '10px', padding: '12px', fontSize: '12px'
                                        }}>
                                            <div className="form-icon"><img alt="flask" className=" text-info mr-2" src={require("../../../assets/images/price/files.svg")} style={{ width: "60px", height: "605px" }} />
                                            </div>
                                            <FormGroup>
                                                <label style={{
                                                    fontWeight: "bold",
                                                    color: "#002940",
                                                    height: "25px",
                                                    padding: "3px",
                                                    display: "block",
                                                    marginTop: "25px",
                                                    marginBottom: "6px"
                                                }} className='f-16 f-w-600 pl-2 label-quoter-mic'>
                                                    {"Listado de indicaciones"}
                                                </label>
                                            </FormGroup>
                                            <Col sm="12">
                                                {
                                                    formMicSampling?.sample_Form?.list_Determinations &&
                                                    formMicSampling.sample_Form.list_Determinations.length > 0 &&
                                                    <ul style={{ marginTop: '0.5rem' }}>
                                                        {
                                                            formMicSampling.sample_Form.list_Determinations.flatMap((_obj, _key) =>
                                                                _obj.listIndication?.map((_ind, _key2) => (
                                                                    <li key={`${_key}-${_key2}`} className='label-dashboard' style={{ color: "#98a6ad", fontWeight: 600 }}>
                                                                        -{_ind.indication ?? "-------"}
                                                                    </li>
                                                                )) || []
                                                            )
                                                        }
                                                    </ul>
                                                }
                                            </Col>
                                        </div>
                                    </div> <br /><br />
                                    <div style={{ padding: "20px" }} className="contact-form pt-0">
                                        <div className="theme-form pr-0 pl-2 shadow-sm" style={{
                                            backgroundColor: 'white', border: '1px solid #e0e0e0',
                                            borderRadius: '10px', padding: '12px', fontSize: '12px'
                                        }}>
                                            <div className="form-icon"><img alt="flask" className=" text-info mr-2" src={require("../../../assets/images/price/Norms.svg")} style={{ width: "70px", height: "605px" }} />
                                            </div>
                                            <FormGroup>
                                                <label style={{
                                                    fontWeight: "bold",
                                                    color: "#002940",
                                                    height: "25px",
                                                    padding: "3px",
                                                    display: "block",
                                                    marginTop: "25px",
                                                    marginBottom: "6px"
                                                }} className='f-16 f-w-600 pl-2 label-quoter-mic'>
                                                    {"Normas aplicadas"}
                                                </label>
                                            </FormGroup>
                                            <Col sm="12">
                                                {
                                                    formMicSampling?.sample_Form?.list_Determinations &&
                                                    formMicSampling.sample_Form.list_Determinations.length > 0 &&
                                                    <div className="activity-">
                                                        {
                                                            formMicSampling.sample_Form.list_Determinations.flatMap((_obj, _key) =>
                                                                _obj.list_nom?.map((_nom, _key2) => (
                                                                    <div className="media" key={`${_key}-${_key2}`}>
                                                                        <div className=""></div>
                                                                        <div className="media-body">
                                                                            <span style={{ color: "#98a6ad" }} className='f-w-600 label-dashboard'>-{_nom.name ?? "-------"}</span>
                                                                        </div>
                                                                    </div>
                                                                )) || []
                                                            )
                                                        }
                                                    </div>
                                                }
                                            </Col>
                                        </div>
                                    </div>
                                    <Col sm="12" style={{ textAlign: "right" }} > <br />
                                        <ButtonGroup className='pt-3' >
                                            <Button
                                                className=" btn-air-danger "
                                                color="success"
                                                size="sm"
                                                onClick={() => handlePreviewSamplings(formMicSampling.is_edit ? true : false)}
                                            ><i className="icofont icofont-diskette f-14"></i>&nbsp;{formMicSampling.is_edit ? "Guardar Edición" : "Guardar"}
                                            </Button>
                                            <Button
                                                className=" btn-air-danger "
                                                color="danger"
                                                size="sm"
                                                onClick={() => handleResetSamplings()}

                                            ><i className="fa fa-reply f-14"></i>&nbsp;Regresar
                                            </Button>

                                        </ButtonGroup>
                                    </Col>
                                </Col>
                            </Row>
                        </Col>
                    </Card>
                    {
                        // ? END FORM SAMPLINGS SAVE
                    }<br /> <br /> <br /> <br />
                </Col>
                }
            </div>
            <ModalRecollected
                {
                ...{ modalCollected, handleToggleCollected, dataCollected, saveDetailSamplingsNotCollected }
                }
            />
            <ModalPreviewSamplings
                {
                ...{ modalSamplings, handleToggleSamplings, saveSamplings, loadingSamplings, formMicSampling, cancell_Samplings, saveEditSamplings }
                }
            />
            <ModalValidSamplings
                {
                ...{ handleToggleValid, modalValid, listNot }
                }
            />
            <ModalCreateSample
                {
                ...{ modalSample, toggleSample, handleText, saveCreateSample }
                }

            />

            <ModalCreateSite
                {
                ...{ modalSite, toggleSite, handleTextSite, saveCreateSite }
                }


            />

            <CustomAlertDialogGlobal
                visible={customAlert.visible}
                mode={customAlert.mode}
                type={customAlert.type}
                title={customAlert.title}
                message={customAlert.message}
                buttonText={customAlert.buttonText}
                cancelText={customAlert.cancelText}
                onAccept={customAlert.onAccept}
                onCancel={customAlert.onCancel}

                showDatePicker={customAlert.showDatePicker}
                minDate={minDate}
            />


        </Fragment>
    )
}